import "../styles/Footer.css";
import dicgcLogo from "../assets/photos/dicgc-logo.png";
import dicgcQR from "../assets/photos/dicgc-qr.png";

import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {

    const openMap = () => {
        window.open(
            "https://www.google.com/maps/search/?api=1&query=446+Jagannath+ShankarSeth+Road+Chira+Bazaar+Mumbai+400002",
            "_blank"
        );
    };

    return (
        <footer className="bank-footer">

            <div className="footer-main">

                <div>
                    <h4>About</h4>
                    <ul>
                        <li>
                            <Link to="/about" className="footer-link">About Us</Link>
                        </li>
                        <li>
                            <Link to="/board-of-directors" className="footer-link">Board of Directors</Link>
                        </li>
                        <li>
                            <Link to="/financials" className="footer-link">Financials</Link>
                        </li>
                        <li>
                            <Link to="/shareholders" className="footer-link">Shareholders</Link>
                        </li>
                        <li>
                            <Link to="/bank-holidays" className="footer-link">Bank Holidays</Link>
                        </li>
                        <li>
                            <Link to="/careers" className="footer-link">Careers</Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4>Services</h4>
                    <ul>
                        <li>
                            <Link to="/contact" className="footer-link">Contact Us</Link>
                        </li>
                        <li>
                        <Link to="/interest-rates" className="footer-link">Interest Rates</Link>
                        </li>
                        <li>
                            <Link to="/fees-charges" className="footer-link">Fees & Service Charges </Link>
                        </li>
                        <li>
                        <Link to="/atm-complaint" className="footer-link">ATM Complaints Redressal </Link>
                        </li>
                        <li>
                        <Link to="/dicgc" className="footer-link">DICGC</Link>
                        </li>
                        <li>
                        <Link to="/grievance" className="footer-link">Grievance Redressal</Link>
                        </li>
                        <li>
                        <Link to="/unclaimed-deposits" className="footer-link" >Unclaimed Deposits</Link>
                        </li>
                        <li>
                        <Link to="/secured-assets" className="footer-link" >Secured Assets Possessed</Link>
                        </li>
                        <li>
                            <Link to="/disclaimer" className="footer-link">Disclaimer</Link>
                        </li>
                        <li>
                            <Link to ="/kyc" className="footer-link">Know Your Customer</Link>
                        </li>
                        <li>
                            <Link to="/customer-awareness" className="footer-link">Customer Awareness</Link>
                        </li>
                        <li>
                            <Link to="/dosdonts" className="footer-link">Do's & Don'ts</Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4>Branches</h4>
                    <ul>
                        <li><Link to="/branch-banking" className="footer-link">Branch Banking</Link></li>
                        <li>
                            <Link to="/atm-banking" className="footer-link">ATM Banking</Link>
                        </li>
                        <li>
                            <Link to="/mobile-banking" className="footer-link"> Mobile Banking </Link>
                        </li>
                        <li>
                            <Link to="/sms-banking" className="footer-link">SMS Banking</Link>
                        </li>
                        <li>
                            <Link to="/upi" className="footer-link">Unified Payments Interface (UPI)</Link>
                        </li>

                    </ul>
                </div>

                <div>
                    <h4>Loan Calculator</h4>
                    <ul>
                        <li>
                        <Link to="/loan-emi-calculator" className="footer-link">Loan EMI Calculator</Link>
                        </li>
                        <li>
                        <Link to ="/download-center" className="footer-link" >Download Forms </Link>
                        </li>
                        <li>
                        <Link to="/contact" className="footer-link">Feedback & Complaints</Link>
                        </li>
                        <li>
                        <Link to="/gallery" className="footer-link">Gallery</Link>
                        </li>
                        <li>
                        <Link to="/news" className="footer-link">Latest News</Link>
                        </li>
                    </ul>
                </div>

                <div className="footer-cards">

                    <div className="dicgc-card">

                        <a
                            href="https://www.dicgc.org.in"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={dicgcLogo} alt="DICGC" className="dicgc-logo"/>
                        </a>

                        <img src={dicgcQR} alt="DICGC QR" className="dicgc-qr"/>

                        <p>The Sahyadri Sahakari Bank Ltd is registered with DICGC</p>

                    </div>

                    <div className="contact-card">
                        <h3>Ways to Reach Out</h3>

                        <p><FaPhoneAlt className="icon"/> 22017477 / 22016770</p>

                        <p>
                            <FaMapMarkerAlt className="icon"/>
                            446, Jagannath, ShankarSeth Road,<br/>
                            Chira Bazaar, Mumbai - 400002
                        </p>

                        <p><FaEnvelope className="icon"/> customersupport@sahyadribank.com</p>

                        <button onClick={openMap}>Locate Us</button>
                    </div>

                </div>

            </div>

            <div className="footer-copy">
                Copyright © 2026 The Sahyadri Sahakari Bank Ltd. All Rights Reserved
            </div>

        </footer>
    );
}

export default Footer;
